// extracted by mini-css-extract-plugin
export default {"wrapper":"privacy_wrapper__dnB9k"};